import Component from './CreatePO';

export default Component;
